export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
          À propos de moi
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="flex justify-center">
            <div className="w-96 h-96 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://justenjay1234.github.io/fouedieua/foued.jpg"
                alt="Foued Hessin"
                title="Foued Hessin"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">
              Je suis Foued Hassin,
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              récemment diplômé d'une licence en sciences de gestion, avec une spécialisation en marketing, ainsi que d'un master en marketing digital. Fort d'une expérience pratique dans ce domaine, je me suis tourné vers le développement web, explorant des technologies telles que Python, HTML et WordPress. Je suis actuellement engagé dans des formations en ligne couvrant l'informatique, le marketing digital et divers autres domaines afin d'enrichir mes compétences.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Passionné par le marketing digital, je suis en quête de nouvelles opportunités et défis pour mettre en pratique mes connaissances et apporter une valeur ajoutée au monde professionnel. Rigoureux et motivé, je préfère travailler en équipe et m'investir pleinement dans chaque projet.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
